import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslations } from "../../../providers/useTranslations";
import styles from "./Promotion.module.scss";
export const Promotion = ({ code, imageUrl, onClick, isActive }) => {
    const { __ } = useTranslations();
    return (_jsx("button", { type: "button", className: classNames(styles.promotionButton, { [styles.isActive]: isActive }), onClick: onClick, "aria-label": `${__("libs.ui.promotion.button_aria_label")} ${code}`, children: _jsx("img", { src: imageUrl, alt: code }) }));
};
//# sourceMappingURL=Promotion.js.map